import { useEffect } from 'react';

import { Async } from '../../../../weborder/Data';
import { OrderHistory } from '../../../api/order/order.types';

type UseOrderHistory = {
  data: OrderHistory[];
  isEmpty: boolean;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
};

export const useOrderHistory = (
  isEnabled: boolean,
  loadOrderHistory: () => void,
  orderHistory: Async<OrderHistory[]>,
): UseOrderHistory => {
  const isLoading = orderHistory.status === 'pending' && isEnabled;
  const isSuccess = orderHistory.status === 'success';
  const isError = orderHistory.status === 'none';
  const isEmpty =
    orderHistory.status === 'success' && orderHistory.data.length === 0;

  useEffect(() => {
    if (isLoading) {
      // * Redux state - Data.Async<OrderHistory[]>
      // - set state.orders.history
      loadOrderHistory();
    }
  }, [orderHistory.status, isEnabled]);

  const orderHistoryData = isSuccess ? orderHistory.data : [];

  return {
    data: orderHistoryData,
    isEmpty,
    isError,
    isLoading,
    isSuccess,
  };
};
